import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_24 = { class: "col-lg-8 fv-row" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = {
  value: "",
  disabled: ""
}
const _hoisted_43 = { value: 1 }
const _hoisted_44 = { value: 2 }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_48 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_49 = { class: "indicator-label" }
const _hoisted_50 = { class: "indicator-progress" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewOrganizer')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('organizerNameArLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('organizerNameEnLang')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('phoneNumber')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "phone",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('organizerPhone')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "phone" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('logo')) + ": ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('organizerLogo'),
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previewLogo && _ctx.previewLogo(...args)))
                    }, null, 40, _hoisted_25),
                    (_ctx.logoPreview)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("img", {
                            src: _ctx.logoPreview,
                            alt: "Logo Preview",
                            class: "img-thumbnail",
                            style: {"max-width":"200px","max-height":"150px","object-fit":"contain"}
                          }, null, 8, _hoisted_27)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('mapLogo')) + ": ", 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('organizerMapLogo'),
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previewMapLogo && _ctx.previewMapLogo(...args)))
                    }, null, 40, _hoisted_31),
                    (_ctx.mapLogoPreview)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("img", {
                            src: _ctx.mapLogoPreview,
                            alt: "Map Logo Preview",
                            class: "img-thumbnail",
                            style: {"max-width":"200px","max-height":"150px","object-fit":"contain"}
                          }, null, 8, _hoisted_33)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('video')) + ": ", 1),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_Field, {
                      type: "file",
                      accept: "video/*",
                      name: "video",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('organizerVideo')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ErrorMessage, { name: "video" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.translate('category')), 1),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "categoryId",
                      class: "form-select form-select-lg form-select-solid"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.translate('selectCategory')), 1),
                        _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.translate('private')), 1),
                        _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.translate('government')), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "categoryId" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_50, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_51
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}